//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'

//#endregion


import { Enums } from '../../../models/common/enums'

import { LocalDictionaryFactory } from '../../api/api.module'
import { EventsNames } from '../../../helpers/events-names'

import { LoggerService } from '../../common/common.module'
import { CommonHelper } from '../../../helpers/common-helper'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { TemplateHelper, ConfigHelper, ConvertHelper, ToastHelper } from '../../../helpers'
import { UserSessionService } from '../../../services/user-session'
import { GridService } from '../../../services/grid'
import { SystemInternationalizationService, SystemService } from '../../../services/system'
import { SupplierService } from '../../../services/supplier'
import { Language } from '../../../services/system/system.service.interfaces'

import { OperatorLayoutSettings } from './../../../helpers/operator-layout-settings'
import { Details, DetailsScope, DetailsAccordion, DetailsAccordionSection } from '../../common/common.details'
import { DetailsPopupOptions, DetailsOptions } from '../../common/details-popup/details-popup.directive'
import { GridOptions, GridTypes, GridController } from '../../common/grid'
import { TreeListOptions } from '../../common/tree-list'
import { Activity } from '../../../models/common/activity'
import { OpDataTypeInGroup, OpSupplier, OpFile } from '../../../models/core'
import { DetailsParametersOptions } from '../../common/details-parameters/details-parameters.directive'
import { IIMRImage, IMRImageInitializedArgs, IMRImageOptions } from '../../../modules/common/image'
import { FileUploaderOptions } from '../../common/file-uploader/file-uploader.directive'
import { CreateEditMessageOptions, ICreateEditMessage, SupplierCreateEditMessageSubmitArgs } from '../components/create-edit-supplier-message/create-edit-supplier-message.interfaces'
import { OpSupplierData } from '../../../models/core/op-supplier-data'
import { IIMRPopup, IMRPopupOptions } from '@imr/controls.angularjs/components/overlay/popup'
import { IMRComponentInitializedArgs } from '@imr/controls.angularjs/components/base'
import { IMRBaseControlEventArgs } from '../../common/base'
import { DataProviderRequest } from '../../../data-provider'
import { IIMRConfirmationPopup, IMRConfirmationPopupInitializedArgs, IMRConfirmationPopupOptions } from '../../common/confirmation-popup2'

interface SupplierDetailsScope
    extends DetailsScope {
    SUPPLIER_COMMON_TAB_NAME: string
    SUPPLIER_PARAMS_ACCORDION_NAME: string
    SUPPLIER_LOGO_ACCORDION_NAME: string
    SUPPLIER_MESSAGES_ACCORDION_NAME: string
    DELETE_CONFIRMATION_POPUP_ID: string
    SUPPLIER_EDIT_BUTTON: string
    SUPPLIER_MESSAGES_GRID_NAME: string

    noActiveAccordionsText: string

    id: number
    popupTitle: string
    detailsParametersOptions: DetailsParametersOptions
    detailedParamGridOptions: TreeListOptions
    deleteConfirmationOptions: {
        title: string
        onConfirmed: () => void
    }
    imageOptions: IMRImageOptions
    logoUploaderPopoverOptions: DevExpress.ui.dxPopoverOptions
    logoUploadToolbarOptions: DevExpress.ui.dxToolbarOptions
    logoFileToUpload: OpFile
    fileUploaderOptions: FileUploaderOptions
    isLoadingLogo: boolean

    messagesGridOptions: GridOptions
    createEditSupplierMessageOptions: CreateEditMessageOptions
    supplierAddTemplateButtonOptions: DevExpress.ui.dxButtonOptions
    supplierEditTemplateButtonOptions: DevExpress.ui.dxButtonOptions
    supplierDeleteTemplateButtonOptions: DevExpress.ui.dxButtonOptions
    isEditTempplateAllowed(): boolean
    previewTemplate: string
    previewTemplatePopupOptions: IMRPopupOptions

    confirmationPopupOptions: IMRConfirmationPopupOptions

    deleteTemplateButtonOptions: DevExpress.ui.dxButtonOptions
    deleteTemplateConfirmationPopupOptions: IMRConfirmationPopupOptions
    deleteLogoConfirmationPopupOptions: IMRConfirmationPopupOptions
}

export class SupplierDetailsDirectiveController
    extends Details<SupplierDetailsScope> {

    //#region Consts

    private static get LOG_STRING(): string { return '[SIMAX.Supllier.Details.Controller] - %s' }

    //#endregion Consts End


    //#region Members

    private referenceObject: OpSupplier
    private referenceObjectId: number

    private imageController: IIMRImage
    private logoUploaderPopover: DevExpress.ui.dxPopover
    private logoUploader: DevExpress.ui.dxFileUploader

    private supplierMessageComponent: ICreateEditMessage
    private supplierMessageTemplateComponent: IIMRPopup
    private messagessGrid: GridController<OpFile>
    private supplierEditTemplateButton: DevExpress.ui.dxButton

    private getSupplierRequest: DataProviderRequest<OpSupplier> = null
    private confirmationPopup: IIMRConfirmationPopup
    private deleteTemplateConfirmationPopup: IIMRConfirmationPopup
    private deleteLogoConfirmationPopup: IIMRConfirmationPopup
    private fileToDelete: OpFile

    //#endregion


    //#region Ctro

    constructor(
        protected $scope: SupplierDetailsScope,
        protected $q: ng.IQService,
        protected logger: LoggerService,
        protected $timeout: ng.ITimeoutService,
        protected localDictionary: LocalDictionaryFactory,
        protected userSession: UserSessionService,
        private systemService: SystemService,
        private supplierService: SupplierService,
        private gridService: GridService,
        private systemInternationalizationService: SystemInternationalizationService,
        protected referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $q, logger, localDictionary, OperatorLayoutSettings.MeterPopupTabActive, userSession, referenceType)

        this.setTemplateConsts()
        this.setConfirmationsOptions()
        this.setEvents()
        this.setOptions()
        this.setImageOptions()
        this.setLogoUploaderPopoverOptions()
        this.initializeConfirmationPopup()

        if (this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_LIST)) {
            this.configureTabs(this.getTabs())
        }
    }

    //#endregion


    //#region Events

    private onRefresh(toRefresh: OpSupplier = null): void {
        this.$scope.options.isDataLoaded = false
        const deferred: JQueryDeferred<OpSupplier> = $.Deferred<OpSupplier>()

        if (toRefresh == null) {
            this.getSupplierRequest = this.supplierService.getSupplier(this.referenceObjectId)

            this.getSupplierRequest
                .then((result: OpSupplier) => {
                    this.$scope.popupTitle = result.toString()
                    deferred.resolve(result)
                })
                .fail((error: any) => {
                    this.hidePopup()
                    deferred.resolve(null)
                })
                .always(() => {
                    this.$scope.showTabs = true
                    this.$scope.isLoadingLogo = true
                })
        } else {
            deferred.resolve(toRefresh)
        }

        deferred
            .promise()
            .then((result: OpSupplier) => {
                if (result && (!this.referenceObject || this.referenceObject.idSupplier == result.idSupplier)) {
                    this.referenceObject = result

                    return $.when(
                        this.setBasicParameters(),
                        this.getLogo(),
                        this.setMessagesGridOptions(),
                        this.setCreateEditSupplierMessageOptions()
                    )
                }
            })
            .always(() => {
                this.$scope.options.isDataLoaded = true
            })
    }

    private onClear(): void {
        this.$scope.popupTitle = ''
        this.$scope.showTabs = false
        this.$scope.schemas = null
        this.$scope.devicesGridOptions = null
        this.$scope.measurementsBridge = null
        this.$scope.deviceBridge = null
        this.$scope.historySource = null
        this.$scope.connectedObject = null

        this.referenceObject = null
    }

    private onOpen(options: DetailsOptions): void {
        this.$scope.detailsOpenParams = options

        this.referenceObjectId = options.referenceObjectId

        this.onClear()
        this.onRefresh()
        this.showPopup()
    }

    private onClose(): void {
        this.hidePopup()
    }

    private onDelete(): void {
        this.confirmationPopup.show()
    }

    private onConfirmDelete(): void {
        this.supplierService
            .deleteSupplier(this.referenceObject.idSupplier)
            .then(() => {
                this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
                this.hidePopup()
            })
            .fail((error: any) => {
                this.logger.log(error)
            })
    }

    private onUpdateSupplier(args: any[]): void {
        if (_.size(args) > 0) {
            const opSupplier: OpSupplier = args[0]
            if (opSupplier != null && opSupplier.idSupplier === this.referenceObject.idSupplier) {
                this.onRefresh(opSupplier)
            }
        }
    }

    private onCreateEditMessageTemplate(file?: OpFile): void {
        if (this.supplierMessageComponent != null) {
            this.$scope.createEditSupplierMessageOptions.messageFile = file
            this.$scope.createEditSupplierMessageOptions.messageFiles = this.referenceObject.currentMessages

            let idLanguage: number = this.userSession.getDataProvider().System.getCurrentLanguageId()

            if (file == null) {
                this.$scope.createEditSupplierMessageOptions.idLanguage = idLanguage
                this.$scope.createEditSupplierMessageOptions.existedIdLanguages = this.getExistingLanguageIds()
            } else {
                this.$scope.createEditSupplierMessageOptions.existedIdLanguages = []
                const dataList: OpSupplierData[] = this.referenceObject.dataList.getDataList(Enums.DataType.SUPPLIER_ORDER_GAS_EMAIL_TEMPLATE)
                if (_.size(dataList) > 0) {
                    const fileData: OpSupplierData = dataList.find((data: OpSupplierData) => data.value == file.idFile)

                    if (fileData != null) {
                        const langData: OpSupplierData = this.referenceObject.dataList.getData(Enums.DataType.SUPPLIER_ORDER_GAS_EMAIL_ID_LANGUAGE, fileData.indexNBR)

                        if (langData != null) {
                            idLanguage = langData.value
                        }
                    }
                }
            }

            this.$scope.createEditSupplierMessageOptions.idLanguage = idLanguage
            this.supplierMessageComponent.updateFileSource(file)
            this.supplierMessageComponent.show()
        }
    }

    private onDeleteSupplierTemplateFile(file: OpFile): JQueryPromise<void> {
        this.$scope.isLoading = true

        return this.supplierService
            .deleteSupplierMessageFile(this.referenceObject.idSupplier, file, 0)
            .then(() => {
                this.referenceObject.currentMessages = this.referenceObject.currentMessages.filter((fileMsg: OpFile) => fileMsg.idFile != file.idFile)
                this.messagessGrid.setDataSource(this.referenceObject.currentMessages)

                const templateDataToRemove: OpSupplierData = this.referenceObject.dataList.toArray().find((data: OpSupplierData) => data.idDataType == Enums.DataType.SUPPLIER_ORDER_GAS_EMAIL_TEMPLATE && data.value == file.idFile && data.opState != Enums.OpChangeState.Delete)

                if (templateDataToRemove != null) {
                    const langDataToRemove: OpSupplierData = this.referenceObject.dataList.toArray().find((data: OpSupplierData) => data.idDataType == Enums.DataType.SUPPLIER_ORDER_GAS_EMAIL_ID_LANGUAGE && data.indexNBR == templateDataToRemove.indexNBR && data.opState != Enums.OpChangeState.Delete)

                    this.referenceObject.dataList.removeValue(templateDataToRemove.idDataType, templateDataToRemove.indexNBR, templateDataToRemove.idData)

                    if (langDataToRemove != null) {
                        this.referenceObject.dataList.removeValue(langDataToRemove.idDataType, langDataToRemove.indexNBR, langDataToRemove.idData)
                    }
                }
            })
            .always(() => {
                this.$scope.isLoading = false
            })
    }

    private getExistingLanguageIds(): number[] {
        return this.referenceObject
            .dataList
            .toArray()
            .filter((data: OpSupplierData) => {
                if (data.idDataType === Enums.DataType.SUPPLIER_ORDER_GAS_EMAIL_ID_LANGUAGE && data.opState !== Enums.OpChangeState.Delete) {
                    return true
                }

                return false
            })
            .map((data: OpSupplierData) => data.value)
    }

    //#endregion


    //#region Setup

    public getAccordions(): DetailsAccordion[] {
        const accordions: DetailsAccordion[] = []

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SupplierParameters) ||
            !this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SupplierLogo)) {
            const items: DetailsAccordionSection[] = []

            if (!this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SupplierParameters)) {
                items.push({
                    name: this.$scope.SUPPLIER_PARAMS_ACCORDION_NAME,
                    title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BasicParameters),
                    showInTab: this.$scope.SUPPLIER_COMMON_TAB_NAME,
                    visible: true,
                    showStatus: false,
                    canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_EDIT)
                        && !this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SupplierParameters),

                    editMethod: (): void => {
                        this.supplierService.openEdit(this.referenceObject.idSupplier, this.referenceObject)
                    }
                })
            }

            if (!this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SupplierLogo)) {
                items.push({
                    name: this.$scope.SUPPLIER_LOGO_ACCORDION_NAME,
                    title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Logo),
                    showInTab: this.$scope.SUPPLIER_COMMON_TAB_NAME,
                    visible: true,
                    showStatus: false,
                    canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_EDIT)
                        && !this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SupplierLogo),

                    editMethod: (): void => {
                        if (this.logoUploader != null) {
                            this.logoUploader.reset()
                        }
                        if (this.logoUploaderPopover != null) {
                            this.logoUploaderPopover.show()
                        }
                    }
                })
            }

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.SupplierDetailsAccordions, 0, items))
        }

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SupplierMessages)) {
            const items: DetailsAccordionSection[] = []
            items.push({
                name: this.$scope.SUPPLIER_MESSAGES_ACCORDION_NAME,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MessageTemplates),
                showInTab: this.$scope.SUPPLIER_COMMON_TAB_NAME,
                visible: true,
                showStatus: true,
                canEdit: false,
                status: (): string => {
                    return this.referenceObject ? _.size(this.referenceObject.currentMessages) + '' : ''
                }
            })

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.SupplierDetailsAccordions, 1, items))
        }

        return accordions
    }

    private setOptions(): void {
        this.$scope.options = <DetailsPopupOptions>{
            id: this.$scope.id,
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DETAILS, this.moduleName),

            openEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName),
            closeEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName),

            delHasPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_DELETE) ? Activity[Activity.SUPPLIER_DELETE] : null,

            deleteMethod: () => this.onDelete(),
            getAccordionDataMethod: () => { return this.getAccordionData() },
            getAccordionSelectionMethod: () => { return this.getAccordionSelection() },
            updateAccordionMethod: (names: any[]) => { return this.updateAccordions(names) }
        }

        this.$scope.supplierAddTemplateButtonOptions = {
            visible: this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_EDIT)
                && !this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SupplierMessages),
            icon: "add",
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Add),
            onClick: (e: any) => this.onCreateEditMessageTemplate()
        }

        this.$scope.supplierEditTemplateButtonOptions = {
            visible: this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_EDIT)
                && !this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SupplierMessages),
            onInitialized: (e: any) => {
                this.supplierEditTemplateButton = e.component
            },
            icon: "edit",
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit),
            disabled: true,
            onClick: (e: any) => {
                if (this.messagessGrid.selectedItem != null) {
                    this.onCreateEditMessageTemplate(this.messagessGrid.selectedItem)
                }
            }
        }

        this.$scope.isEditTempplateAllowed = (): boolean => {
            if (this.messagessGrid != null && this.messagessGrid.selectedItem != null) {
                return false
            }

            return true
        }

        this.$scope.previewTemplatePopupOptions = {
            innerOptions: {
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TemplatePreview),

                onHidden: () => { },
            },

            onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
                this.supplierMessageTemplateComponent = e.component
            }

        }

        this.$scope.supplierDeleteTemplateButtonOptions = {
            visible: this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_EDIT)
                && !this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SupplierMessages),
            template: TemplateHelper.getIcon(ConfigHelper.Icon.DELETE),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Delete),
            onClick: (e: any) => {
                if (this.deleteLogoConfirmationPopup != null && this.$scope.imageOptions.image != null) {
                    this.deleteLogoConfirmationPopup.show()
                }
            }
        }
    }

    private setBasicParameters(): JQueryPromise<void> {
        const def: JQueryDeferred<void> = $.Deferred<void>()
        this.$scope.detailsParametersOptions = null

        this.supplierService
            .getBasicParametrsDataTypeGroup()
            .then((dataTypeInGroup: OpDataTypeInGroup[]) => {
                this.$scope.detailsParametersOptions = {
                    dataTypes: dataTypeInGroup,
                    referenceType: this.referenceType,
                    referenceObject: this.referenceObject,
                    useDynamicValues: true,
                    onDataLoaded: () => {
                        def.resolve()
                    }
                }
            })
            .catch(() => {
                def.reject()
            })

        if (this.isAccordionHidden(this.$scope.SUPPLIER_PARAMS_ACCORDION_NAME)) {
            def.resolve()
        }

        return def.promise()
    }

    private savelogo(file: OpFile) {
        this.$scope.isLoadingLogo = true
        this.logoUploaderPopover.hide()
        this.supplierService
            .saveSupplierLogo(this.referenceObjectId, file)
            .then((logo: OpFile) => {
                this.$scope.imageOptions.image = logo
                this.imageController.setImage(logo)
            })
            .always(() => {
                this.$scope.isLoadingLogo = false
            })
    }

    private deleteLogo() {
        this.$scope.isLoadingLogo = true
        const logo: OpFile = this.$scope.imageOptions.image
        logo.opState = Enums.OpChangeState.Delete

        this.supplierService
            .saveSupplierLogo(this.referenceObjectId, logo)
            .then(() => {
                this.$scope.imageOptions.image = null
                this.imageController.setImage(null)
            })
            .always(() => {
                this.$scope.isLoadingLogo = false
            })
    }

    private getLogo(): JQueryPromise<void> {
        this.$scope.isLoadingLogo = true

        return this.supplierService
            .getSupplierLogo(this.referenceObjectId)
            .then((logo: OpFile) => {
                if (logo != null) {
                    if (this.imageController != null) {
                        this.imageController.setImage(logo)
                    }
                    if (this.$scope.imageOptions != null) {
                        this.$scope.imageOptions.image = logo
                    }
                }
            })
            .always(() => {
                this.$scope.isLoadingLogo = false
            })
    }

    private setImageOptions(): void {
        this.$scope.imageOptions = {
            onInitialized: (e: IMRImageInitializedArgs) => { this.imageController = e.component },
        }
    }

    private setMessagesGridOptions(): void {
        this.$scope.messagesGridOptions = {
            name: this.$scope.SUPPLIER_MESSAGES_GRID_NAME,
            idReferenceType: Enums.ReferenceType.IdFile,
            type: GridTypes.NO_SEARCH_BAR_SMALL,
            buttonsOptions: {
                enabled: false,
            },
            addCustomFilters: true,
            dataSource: this.referenceObject.currentMessages,
            columnsDictionary: this.supplierService.getMessagesGridColumns((file: OpFile) => {
                if (this.deleteTemplateConfirmationPopup != null) {
                    this.fileToDelete = file
                    this.deleteTemplateConfirmationPopup.show()
                }
            }),
            allowColumnReordering: false,
            onRowDoubleClick: (e: any) => {
                this.showPreview(e.selectedRowsData)

                if (this.supplierEditTemplateButton != null) {
                    this.supplierEditTemplateButton.option({ disabled: false })
                }
            },
            onSelectionChanged: (e: any) => {
                if (this.supplierEditTemplateButton != null) {
                    this.supplierEditTemplateButton.option({ disabled: _.size(e.selectedRowsData) === 0 })
                }
            },
            onInitialized: (e: any, messagessGrid: GridController<OpFile>) => { this.messagessGrid = messagessGrid }
        }
    }

    private setLogoUploaderPopoverOptions(): void {
        this.$scope.logoUploaderPopoverOptions = {
            width: 300,
            height: 250,
            target: `#${this.$scope.SUPPLIER_EDIT_BUTTON}${this.$scope.SUPPLIER_LOGO_ACCORDION_NAME}`,
            bindingOptions: {
                visible: 'logoUploaderPopoverVisible'
            },
            onHiding: () => {
                this.$scope.logoUploaderPopoverVisible = false
            },
            onShowing: () => { },
            onInitialized: (e: any) => {
                this.logoUploaderPopover = e.component
            }
        }

        this.$scope.fileUploaderOptions = <FileUploaderOptions>{
            acceptValue: CommonHelper.fileExtensionsToMediaTypes(['png', 'jpg', 'svg', 'jpeg']),
            uploaderVisible: true,
            resetAfterReadEnd: true,
            onReadEnd: (reader, fileName) => {
                let readedBytes: string[] = reader.result.split(',')

                let fileBytes = readedBytes.slice(1).join(',')

                let logo: OpFile = new OpFile()
                logo.idFile = 0
                logo.physicalFileName = fileName
                logo.description = ''

                logo.insertDate = new Date()
                logo.fileBytes = fileBytes
                logo.size = atob(fileBytes).length
                logo.opState = Enums.OpChangeState.Modified

                this.$scope.logoFileToUpload = logo
                this.savelogo(logo)
            },
            onSubmitClick: () => { }
        }
    }

    private setConfirmationsOptions(): void {
        this.$scope.deleteConfirmationOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),
            onConfirmed: () => this.onConfirmDelete()
        }
    }

    private setCreateEditSupplierMessageOptions(file?: OpFile): void {
        this.$scope.createEditSupplierMessageOptions = {
            idSupplier: this.referenceObject.idSupplier,
            idLanguage: this.userSession.getDataProvider().System.getCurrentLanguageId(),
            existedIdLanguages: [],
            messageFile: file,
            messageFiles: this.referenceObject.currentMessages,
            onInitialized: (e: IMRBaseControlEventArgs<ICreateEditMessage>) => {
                this.supplierMessageComponent = e.component
            },
            onSubmit: (e: SupplierCreateEditMessageSubmitArgs) => {
                e.component.showLoading()
                return this.saveMessageTemplate(e.idLanguage, e.template)
                    .always(() => {
                        e.component.hideLoading()
                    })
            }
        }
    }

    private showPreview(file: OpFile): void {
        if (this.supplierEditTemplateButton != null) {
            this.supplierEditTemplateButton.option({ disabled: _.size(file) === 0 })
        }

        if (this.supplierMessageTemplateComponent != null && this.messagessGrid.selectedItem != null) {
            this.supplierMessageTemplateComponent.show()
            this.supplierMessageTemplateComponent.showLoading()
            this.supplierService
                .getMessageFileContent(this.messagessGrid.selectedItem.idFile)
                .then((opFile: OpFile) => {
                    let fileData: number[] = null
                    if (typeof (<number[]>opFile.fileBytes).map !== 'function') {
                        fileData = ConvertHelper.base64ToByteArray(opFile.fileBytes as string)
                    }
                    else {
                        fileData = <number[]>opFile.fileBytes
                    }

                    this.$scope.previewTemplate = ConvertHelper.byteArrayToUnicodeString([].slice.apply(fileData))
                })
                .always(() => {
                    this.supplierMessageTemplateComponent.hideLoading()
                })
        }
    }

    private saveMessageTemplate(idLanguage: number, template: string): JQueryPromise<void> {
        const deferred: JQueryDeferred<void> = $.Deferred<void>()

        const data: OpSupplierData = _.find(this.referenceObject.dataList.getDataList(Enums.DataType.SUPPLIER_ORDER_GAS_EMAIL_ID_LANGUAGE), (data: OpSupplierData) => data.value == idLanguage && data.opState != Enums.OpChangeState.Delete)

        if (this.$scope.createEditSupplierMessageOptions.messageFile == null && data != null) {
            ToastHelper.showWarning(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DupplicatedTemplateWarning))
            deferred.reject()
        } else {
            const filteredLang: Language = this.systemInternationalizationService.getLanguages().find((elem) => elem.id == idLanguage)
            let langSign: string

            if (filteredLang != null) {
                langSign = filteredLang.locale
            } else {
                langSign = this.systemInternationalizationService.getLanguages().find((elem: Language) => elem.id == this.userSession.getDataProvider().System.getCurrentLanguageId()).locale
            }

            const nextIndex: number = this.referenceObject.dataList.getNextIndex(Enums.DataType.SUPPLIER_ORDER_GAS_EMAIL_ID_LANGUAGE)

            const file: OpFile = new OpFile()
            file.description = `OrderGasTemplate.${langSign}_supplier_${this.referenceObject.idSupplier}`
            file.insertDate = new Date()
            file.fileBytes = ConvertHelper.unicodeStringToByteArray(template)
            file.size = file.fileBytes.length

            if (this.$scope.createEditSupplierMessageOptions.messageFile == null) {
                file.idFile = 0
                file.opState = Enums.OpChangeState.New
                file.physicalFileName = 'OrderGasTemplate' + ((nextIndex > 0) ? `.${langSign}` : '') + '.txt'

            } else {
                file.idFile = this.$scope.createEditSupplierMessageOptions.messageFile.idFile
                file.opState = Enums.OpChangeState.Modified
                file.physicalFileName = this.$scope.createEditSupplierMessageOptions.messageFile.physicalFileName
            }

            this.supplierService
                .saveSupplierMessageFile(this.referenceObject.idSupplier, file, idLanguage)
                .then((file: OpFile) => {
                    if (this.referenceObject.currentMessages == null) {
                        this.referenceObject.currentMessages = []
                    }

                    if (this.$scope.createEditSupplierMessageOptions.messageFile == null) {
                        this.referenceObject.currentMessages.push(file)

                        const langData: OpSupplierData = new OpSupplierData(null)
                        langData.idDataType = Enums.DataType.SUPPLIER_ORDER_GAS_EMAIL_ID_LANGUAGE
                        langData.value = idLanguage
                        langData.indexNBR = nextIndex

                        this.referenceObject.dataList.push(langData)

                        const fileData: OpSupplierData = new OpSupplierData(null)
                        fileData.idDataType = Enums.DataType.SUPPLIER_ORDER_GAS_EMAIL_TEMPLATE
                        fileData.value = file.idFile
                        fileData.indexNBR = nextIndex

                        this.referenceObject.dataList.push(fileData)
                    } else {
                        const editedFileIndex: number = this.referenceObject.currentMessages.findIndex((opFile: OpFile) => opFile.idFile == file.idFile)

                        if (editedFileIndex != -1) {
                            this.referenceObject.currentMessages[editedFileIndex] = file
                        }
                    }

                    this.$scope.createEditSupplierMessageOptions.messageFile = file

                    this.messagessGrid.setDataSource(this.referenceObject.currentMessages)

                    this.supplierMessageComponent.hide()

                    deferred.resolve()
                })
                .fail(() => {
                    deferred.reject()
                })
        }

        return deferred.promise()
    }

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName) + this.$scope.id,
            (event: ng.IAngularEvent, ...args: any[]) => {
                if (_.size(args) > 2)
                    this.onOpen(args[3])
            }
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName) + this.$scope.id,
            (event: ng.IAngularEvent, ...args: any[]) => this.onClose()
        )

        this.$scope.$on(
            EventsNames.CLOSE_CREATE_EDIT_POPUP,
            (event: ng.IAngularEvent, ...args: any[]) => this.onRefresh(args[0])
        )

        this.$scope.$on(
            EventsNames.UPDATE_SUPPLIER,
            (event: ng.IAngularEvent, ...args: any[]) => this.onUpdateSupplier(args)
        )
    }

    private setTemplateConsts(): void {
        this.$scope.SUPPLIER_COMMON_TAB_NAME = 'SUPPLIER_COMMON_TAB_NAME'
        this.$scope.SUPPLIER_PARAMS_ACCORDION_NAME = 'SUPPLIER_PARAMS_ACCORDION_NAME'
        this.$scope.SUPPLIER_LOGO_ACCORDION_NAME = 'SUPPLIER_LOGO_ACCORDION_NAME'
        this.$scope.SUPPLIER_MESSAGES_ACCORDION_NAME = 'SUPPLIER_MESSAGES_ACCORDION_NAME'
        this.$scope.SUPPLIER_EDIT_BUTTON = 'SUPPLIER_EDIT_BUTTON_'

        this.$scope.SUPPLIER_MESSAGES_GRID_NAME = 'SUPPLIER_MESSAGES_GRID_NAME'

        this.$scope.DELETE_CONFIRMATION_POPUP_ID = this.$scope.detailsPopupId + '_DELETE_CONFIRMATION_POPUP'

        this.$scope.noActiveAccordionsText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoActiveAccordions)

        this.$scope.selectBoxPopupId = new Date().getTime()
    }

    public getTabs(addSchemaTab: boolean = false): { template: string, name: string }[] {
        const tabs: { template: string, name: string }[] = []

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SupplierParameters) ||
            !this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SupplierLogo) ||
            !this.userSession.getLoggedOperator().hasPermission(Activity.SUPPLIER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SupplierMessages)
        ) {
            tabs.push({
                template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Common), ConfigHelper.Icon.HOME, this.userSession),
                name: this.$scope.SUPPLIER_COMMON_TAB_NAME
            })
        }

        return tabs
    }

    //#endregion

    //#region Confirmation Popup    

    private initializeConfirmationPopup(): void {
        this.$scope.confirmationPopupOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),
            content: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName),

            onInitialized: (e: IMRConfirmationPopupInitializedArgs) => {
                this.confirmationPopup = e.component
            },

            onConfirmed: () => {
                this.onConfirmDelete()
            }
        }

        this.$scope.deleteTemplateConfirmationPopupOptions = {
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
            content: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DeleteTemplateQuestion),

            onInitialized: (e: IMRConfirmationPopupInitializedArgs) => {
                this.deleteTemplateConfirmationPopup = e.component
            },

            onConfirmed: () => {
                if (this.fileToDelete != null) {
                    this.onDeleteSupplierTemplateFile(this.fileToDelete)
                        .always(() => {
                            this.fileToDelete = null
                        })
                }
            },

            onDeclined: () => {
                this.fileToDelete = null
            }
        }

        this.$scope.deleteLogoConfirmationPopupOptions = {
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
            content: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DeleteLogoQuestion),

            onInitialized: (e: IMRConfirmationPopupInitializedArgs) => {
                this.deleteLogoConfirmationPopup = e.component
            },

            onConfirmed: () => {
                this.deleteLogo()
            },
        }
    }

    //#endregion

    //#region Backward Compatibility - DO NOT USE, DELETE IN FUTURE

    public resetData(): void { this.onClear() }
    public loadData(id: number, objects: any[]): void { this.onOpen(null) }
    public updateData(result: any): void { this.onRefresh(result) }

    //#endregion Backward Compatibility End
}